<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-layout wrap="">
        <!-- <v-flex xs12 sm6 md2>
           <v-text-field @keyup.enter="search_client_by_code"  v-model="searchClientCode" label="كودالعميل"  ></v-text-field>
            </v-flex> 
             <v-flex xs12 sm6 md4>
                    <v-select
                    v-model="select_client"
                    :items="clients"
                    item-text="name"
                    item-value="id"
                    label="أختر العميل"
                    persistent-hint
                    return-object
                    single-line
                    @change="get_all_info"
                ></v-select>
                  </v-flex> -->
        <v-flex xs12 sm6 md4>
          <v-select
            v-model="select_money"
            :items="moneys"
            item-text="name"
            item-value="id"
            label="  نوع المصروف "
            persistent-hint
            return-object
            single-line
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-autocomplete
            v-model="select_khazna"
            :items="khazinas"
            item-text="name"
            item-value="id"
            label=" أختر الخزينة "
            persistent-hint
            return-object
            single-line
            @change="get_khazina"
          >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-text-field
            v-model="money"
            type="number"
            label="المبلغ"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-text-field v-model="emp_to" label="الشخص المستلم"></v-text-field>
        </v-flex>
        <v-flex xs12 sm10 md10>
          <v-textarea v-model="comment" rows="2" label="تفاصيل"></v-textarea>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-dialog
            ref="dialog2"
            v-model="modal2"
            :return-value.sync="date2"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date2"
                label=" التاريخ اليدوي"
                readonly
                outline
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date2" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal2 = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.dialog2.save(date2)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-btn @click="add_masrof">دفع مصروف</v-btn>
        </v-flex>
      </v-layout>

      <v-data-table
        :headers="headers"
        :items="money_fatworas"
        class="elevation-1"
        v-if="money_fatworas.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td class="text-xs-right">{{ props.item.money_q }}</td>
          <td class="text-xs-right">{{ props.item.emp_responsible_name }}</td>
          <td class="text-xs-right">{{ props.item.emp_name_to }}</td>
          <td class="text-xs-right">
            {{ props.item.money ? props.item.money.name : "" }}
          </td>
          <td class="text-xs-right">{{ props.item.notes }}</td>
          <td class="text-xs-right">{{ props.item.created_at }}</td>
          <td class="text-xs-right">
            <v-btn
              v-if="permissions.delete_all == 1 || user.type == 1"
              @click="delete_masrof(props.item)"
              >حذف</v-btn
            >
          </td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير مصروفات</div>
    </v-container>
  </div>
</template>

<script>
import {
  clients,
  search_client_by_code,
  madionia_client,
  fatworas_client_no_sadad,
  khazinas,
  khazina,
  khazna_fatworas,
  money_fatworas,
  moneys,
  add_masrof,
  delete_masrof
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: " الكود",
        align: "right",
        value: "name",
        sortable: false
      },
      { text: " المبلغ", value: "address", sortable: false, align: "right" },
      {
        text: " الموظف المسئول",
        value: "address",
        sortable: false,
        align: "right"
      },
      { text: "  المستلم", value: "rasid", sortable: false, align: "right" },
      { text: " نوع المصروف", value: "rasid", sortable: false, align: "right" },
      {
        text: "تفاصيل ",
        value: "control",
        sortable: false,
        align: "center"
      },
      {
        text: "التاريخ ",
        value: "control",
        sortable: false,
        align: "center"
      },
      {
        text: "حذف ",
        value: "control",
        sortable: false,
        align: "center"
      }
    ],
    select_client: { id: "" },
    select_khazna: { id: "" },
    select_money: { id: "" },
    search: "",
    comment: "",
    loading: true,
    menu2: false,
    dialog2: false,
    modal2: false,
    date2: new Date().toISOString().substr(0, 10),
    khazina_fatworas: [],
    money_fatworas: [],
    moneys: [],
    clients: [],
    fatworas: [],
    khazinas: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theKhazna: {},
    emp_to: "",
    money: "",
    searchClientCode: "",
    madionia_sabqa: "",
    madionia_sabqa_of_madionia: "",

    khazna_fatwora_table: {
      code: "",
      emp_name: "",
      rasid_before: "",
      money: "",
      rasid_after: "",
      type: "",
      notes: "",
      khazina_id: "",
      action: "",
      created_at: ""
    },

    khazina_update: {
      id: "",
      rasid: ""
    },
    money_fatwora: {
      code: "",
      money_q: "",
      emp_responsible_name: "",
      emp_name_to: "",
      notes: "",
      money_id: "",
      emp_id: "",
      created_at: ""
    }
  }),

  computed: {
    mycode() {
      if (this.khazina_fatworas.length > 0) {
        return (this.code =
          parseInt(
            this.khazina_fatworas[this.khazina_fatworas.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    mycode2() {
      if (this.money_fatworas.length > 0) {
        return (this.code =
          parseInt(this.money_fatworas[this.money_fatworas.length - 1].code) +
          1);
      } else {
        return (this.code = 1000);
      }
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      clients().then(response => {
        this.clients = response.data;
        this.loading = false;
      });

      let myUser = JSON.parse(localStorage.getItem("user"));
      khazinas(myUser.branch_id).then(response => {
        this.khazinas = response.data;
      });

      khazna_fatworas().then(response => {
        this.khazina_fatworas = response.data;
      });

      money_fatworas().then(response => {
        this.money_fatworas = response.data;
      });

      moneys().then(response => {
        this.moneys = response.data;
      });
    },

    search_client_by_code() {
      search_client_by_code(this.searchClientCode).then(response => {
        this.select_client = response.data;
        this.get_all_info();
      });
    },
    get_all_info() {
      this.searchClientCode = this.select_client.code;
      this.fatworas = [];
      this.madionia_sabqa = "";
      this.loading = true;
      fatworas_client_no_sadad(this.select_client.id).then(response => {
        this.fatworas = response.data;
        this.loading = false;
      });
      madionia_client(this.select_client.id).then(response => {
        this.madionia_sabqa =
          (response.data.madionia != 0
            ? parseFloat(response.data.madionia)
            : 0) +
          (response.data.client.rasid_efttahi != ""
            ? parseFloat(response.data.client.rasid_efttahi)
            : 0);
        this.madionia_sabqa_of_madionia =
          response.data.madionia != 0 ? parseFloat(response.data.madionia) : 0;
      });
    },

    get_khazina() {
      khazina(this.select_khazna.id).then(response => {
        this.theKhazna = response.data;
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    add_masrof() {
      if (this.money != "" && this.select_khazna.id != "") {
        if (parseFloat(this.money) <= parseFloat(this.select_khazna.rasid)) {
          let myUser = JSON.parse(localStorage.getItem("user"));

          this.khazna_fatwora_table.code = this.mycode;
          this.khazna_fatwora_table.emp_name = myUser.name;
          this.khazna_fatwora_table.rasid_before = this.select_khazna.rasid;
          this.khazna_fatwora_table.money = this.money;
          this.khazna_fatwora_table.rasid_after = parseFloat(this.money);
          this.khazna_fatwora_table.type = "out";
          this.khazna_fatwora_table.action = "masrof";
          this.khazna_fatwora_table.notes = this.comment;
          this.khazna_fatwora_table.khazina_id = this.select_khazna.id;
          this.khazna_fatwora_table.created_at = this.date2;
          let khazina_fatwora_ = JSON.stringify(this.khazna_fatwora_table);

          this.khazina_update.id = this.select_khazna.id;
          this.khazina_update.rasid = this.money;
          let khazina_ = JSON.stringify(this.khazina_update);

          this.money_fatwora.code = this.mycode2;
          this.money_fatwora.money_q = this.money;
          this.money_fatwora.emp_responsible_name = myUser.name;
          this.money_fatwora.emp_name_to = this.emp_to;
          this.money_fatwora.notes = this.comment;
          this.money_fatwora.money_id = this.select_money.id;
          this.money_fatwora.emp_id = myUser.id;
          this.money_fatwora.created_at = this.date2;
          let money_fatwora_ = JSON.stringify(this.money_fatwora);

          this.do_deposit(khazina_fatwora_, khazina_, money_fatwora_);
        } else {
          this.$swal("Error", "الرصيد غير كافي ", "Error");
        }
      }
    },
    do_deposit(khazina_fatwora_, khazina_, money_fatwora_) {
      this.loading = true;
      var frmData = new FormData();
      frmData.append("khazina", khazina_);
      frmData.append("khazina_fatwora", khazina_fatwora_);
      frmData.append("money_fatwora", money_fatwora_);
      add_masrof(frmData).then(response => {
        this.$router.go(0);
        this.loading = false;
      });
    },

    delete_masrof(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.money_fatworas.indexOf(item);

          this.loading = true;

          delete_masrof(item.id).then(response => {
            this.loading = false;
            this.money_fatworas.splice(index, 1);
            this.close();
            this.$router.go(0);
          });
        }
      });
    },
    push_client_sadad(sadad) {
      this.all_client_sadads.push(sadad);
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
